module.exports = __webpack_public_path__ + "img/open-platform.1a5b7d8.png";